<template>
<modal name="demo-login" transition="pop-out" :width="modalWidth" :focus-trap="true" :height="400">
     <div class="row justify-content-center">
        <div class="col-lg-12">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0"
          >
  <div class="box">
    <div class="box-part" id="bp-left">
        <div class="text-center text-muted mb-4">
                <small>sign in with credentials</small>
              </div>
              <form role="form">
                <base-input
                  alternative
                  class="mb-3"
                  v-model="loginemail"
                  placeholder="Email"
                  addon-left-icon="ni ni-email-83"
                ></base-input>
                <base-input
                  alternative
                  type="password"
                  v-model="loginpassword"
                  placeholder="Password"
                  addon-left-icon="ni ni-lock-circle-open"
                ></base-input>
                <base-checkbox>Remember me</base-checkbox>
                <div
                  v-show="show"
                  id
                  class="logininfobox alert alert-warning mt-2"
                >{{ loginErrorString }}</div>
                <div
                  v-show="showLoading"
                  id
                  class="logininfobox alert alert-warning mt-2"
                >Please wait...</div>
                <div
                  v-show="showSuccess"
                  id
                  class="logininfobox alert alert-success mt-2"
                >Login succesful, please wait...</div>
                <div class="text-center">
                  <base-button
                    @submit="loginProcess"
                    @click="loginProcess"
                    type="primary"
                    class="my-4"
                  >Sign In</base-button>
                </div>
                <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <small>Forgot password?</small>
              </a>
            </div>
            <div class="col-6 text-right">
              <a href="#/register" class="text-light">
                <small>Create new account</small>
              </a>
            </div>
          </div>
              </form>
    </div> 
  </div>
          </card></div></div>
</modal>
</template>
<script>
const MODAL_WIDTH = 656
import { APIURLS } from "../../api/constants";
import axios from "axios";

export default {
  name: 'DemoLoginModal',
  data() {
    return {
      modalWidth: MODAL_WIDTH,
       show: false,
      loginemail: "",
      loginpassword: "",
      showLoading: false,
      showSuccess: false,
      loginErrorString: "Incorrect Username or Password, Please try again",
    }
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH
  },
  methods: {
   
    limitText(count) {
      return `and ${count} other cities`;
    },
  
     logout() {
      localStorage.setItem("userid", "");
      localStorage.setItem("loggedIn", "no");
      localStorage.setItem("customer_id", "");
      localStorage.setItem("email", "");
      localStorage.setItem("name", "");
      localStorage.setItem("user", "");
      //this.$router.push("/");
      this.$root.$emit('loginevent', false);
      
      //this.$router.go(this.$router.currentRoute);
      location.reload(true);
    },
    loginProcess() {
  
      if (this.loginemail == "" || this.loginpassword == "") {
        this.show = true;

        this.loginErrorString =
          "All fields are required for login, please recheck and continue";
      } else {
        this.showLoading = true;
        this.show = false;
        //this.show = false;
        var formData = new FormData();

        formData.append("email", this.loginemail);
        formData.append("password", this.loginpassword);

        axios.post(APIURLS.LOGIN_URL, formData).then((response) => {
          this.showLoading = false;
          var data = response.data;
          if (data.success) {
            this.showSuccess = true;
            localStorage.setItem("userid", data.user.contact_id);
            localStorage.setItem("loggedIn", "yes");
            localStorage.setItem("customer_id", data.user.customer);
            localStorage.setItem("email", data.user.email);
            localStorage.setItem("name", data.user.name);
            localStorage.setItem("user", data.user);
            this.$root.$emit('loginevent', true);
            // this.$router.push("/");
            // location.reload(true);
            this.$modal.hide('demo-login');
            //this.$router.go(this.$router.currentRoute);
            // window.location.href =
            //   "https://followmetraveller.in/";
            //                         admin: 0
            // contact_id: 28
            // customer: 20
            // email: "sajidyoung2006@gmail.com"
            // is_admin: 0
            // logged_in: true
            // name: "Sajid Mathupotra"
            // surname: ""
          } else {
            this.loginErrorString = data.message;
            this.show = true;
          }
          //console.log(response);
        });
      } 
      }
  }
}
</script>
<style>

  
</style>